var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.45 26.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,0A12.28,12.28,0,0,0,5,2.81V6.3a11,11,0,0,1,8-3.56c5.61,0,9.93,4.4,9.93,10.31V21.2A11.75,11.75,0,0,0,26,13,12.82,12.82,0,0,0,13,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.07,12.82V4.66A11.79,11.79,0,0,0,0,12.82a12.82,12.82,0,0,0,13,13,12.46,12.46,0,0,0,8-2.81V19.57A11.27,11.27,0,0,1,13,23.13c-5.61,0-9.9-4.44-9.9-10.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.47.42h-8.8v25h3V3h5.8c3.3,0,5,2,5,4.7s-1.71,4.66-5,4.66H39.49v2.58h4c4.93,0,8-3,8-7.28S48.4.42,43.47.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.67,5.88l2.16-1.63A9.2,9.2,0,0,0,67.1,0a9,9,0,0,0-2.73.42V3.22A7.29,7.29,0,0,1,67,2.73a6.7,6.7,0,0,1,5.65,3.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.3,11.91l-2.77-1.33c-2.27-1.1-4-1.93-4-4.59V1.29a6,6,0,0,0-3.07,5.27c0,3.53,2.73,5.27,5.65,6.67l2.81,1.33c2.47,1.17,4.17,2.09,4.17,4.78v5.12a6.38,6.38,0,0,0,3.07-5.57c0-3.37-2.16-5.23-5.84-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,18.85l-2.2,1.63A10.52,10.52,0,0,0,67,25.86a9.73,9.73,0,0,0,3.22-.53V22.56a10,10,0,0,1-3.19.57c-3.22,0-5.46-2-7-4.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "80.91 0.46 90.43 25.9 91.49 25.9 92.55 23.32 84.17 0.46 80.91 0.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "108.7 16.92 110.3 20.82 117.88 0.46 114.66 0.46 108.7 16.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.88 0.04 92.17 16.84 93.57 20.71 99.41 6.07 107.34 25.9 108.44 25.9 109.31 23.48 99.94 0.04 98.88 0.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.91 17.75 130.89 8.5 129.34 4.82 120.54 25.48 123.65 25.48 125.77 20.4 136.01 20.4 134.87 17.75 126.91 17.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.38 0.04 130.32 2.43 140.18 25.48 143.33 25.48 132.49 0.04 131.38 0.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.88,
    y: 0.46,
    width: 20.59,
    height: 2.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 153.68,
    y: 4.97,
    width: 2.96,
    height: 20.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.53,23.44h-.34V24h.34a.26.26,0,0,0,.27-.26.26.26,0,0,0-.27-.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.51,22a2,2,0,1,0,1.94,2,2,2,0,0,0-1.94-2m.48,3-.51-.68h-.29v.68h-.47V23h.81a.67.67,0,0,1,.74.68.61.61,0,0,1-.33.57l.56.78Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9cd07763378c709b28196d9aab7e8d1c.svg";
export { ForwardRef as ReactComponent };